import { useEffect, useState } from "react";
import { Tabs, Form, message, Input, DatePicker, Modal } from "antd";
import PropTypes from "prop-types";
import moment from 'moment';
import FeatherIcon from 'feather-icons-react';
import { useDispatch, useSelector } from 'react-redux';
import { CheckCircleOutlined } from '@ant-design/icons';
import { AddUser } from '../../style';
import { convertCurrency, ExchangeCurrency } from '../../Filters/FilterConditions';
import { BasicFormWrapper } from '../../../styled';
import { setEditCall, setExPoCall } from '../../../../redux/CrmReduxCalls/EditNavCtrl';
import { DetailsOtherInfoUser } from '../GlobalComponents/UserCardCmnts'
import { DealUpdate } from '../../../../Api/Services/DealApiService'

const LeadTabPage = ({ displayData, currencySettings, dealInitial, setTrigger, ApprovalMessage, AutomationMessage, canUpdateDelete, DealData, getData, permissions, dataPermissions, setErrorData, setIsModalVisible1 }) => {
    const dispatch = useDispatch();
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const { TabPane } = Tabs;
    const [form] = Form.useForm();
    const [expectedClosureDate, setExpectedClosureDate] = useState(null)
    const [revenueStartDate, setRevenueStartDate] = useState(null)
    const [revenueEndDate, setRevenueEndDate] = useState(null)
    const [dealDiscount, setDealDiscount] = useState()
    const [displayDatas, setDisplayDatas] = useState()
    const [dealValues, setDealValue] = useState(0)
    const [typeAction, setTypeAction] = useState()
    const [winProbability, setWinProbability] = useState()
    const [totalDeal, setTotalDeal] = useState(0)
    const [editWon, setEditWon] = useState(false)
    const [edit, setEdit] = useState(false)
    const [pipeLineField, setPipeLineField] = useState()
    const [changeDealMargin, setChangeDealMargin] = useState()
    const [changeDealMargin2, setChangeDealMargin2] = useState()
    const [inLineFields, setInLineFields] = useState(DealData)
    const disabledDate = current => {
        return current && current < moment().startOf('day');
    };
    const RequiredDateFormating = (dateString) => {
        const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
        const formattedDate = parsedDate.format("YYYY-MM-DD");
        return formattedDate;
    }
    const [formDatas, setFormDatas] = useState([
        {
            dealProductId: '',
            productCategory: '',
            productLicenseSellingPriceUnitMonth: '',
            numberOfUnits: '',
            licenseDuration: null,
            // subtotal: '',
            // adjustmentType: '%',
            // adjustments: '',
            total: '',
        },
    ]);
    const requiredFields = ['dealProductId', 'numberOfUnits', 'licenseDuration'];
    const isFormDataValid = formDatas.every(formData => {
        return requiredFields.every(field => {
            const value = formData[field];
            return value !== undefined && value !== '';
        });
    });
    const [servicesData, setServiceData] = useState([
        {
            serviceName: '',
            serviceLineId: '',
            serviceLineCost: '',
        },
    ]);
    const isservicesDataValid = servicesData.every(formData => {
        return Object.values(formData).every(value => value !== undefined && value !== '');
    });
    const [roleData, setRoleData] = useState([
        {
            addStaffRoleId: '',
            country: '',
            rolePerDayRate: '',
            startDate: '',
            endDate: '',
            totalValue: '',
        },
    ]);
    const formatDateString = (dateString, format) => {
        return moment(dateString, "YYYY-MM-DD").format(format);
    };
    const normalizeValue = (value) => {
        if (value === undefined || value === "") return null;
        return value;
    };
    function formatDate(value, profile) {
        if (!value) return "";
        const format = profile?.dateFormate && profile?.dateFormate !== "" ? profile?.dateFormate : "YYYY-MM-DD";
        return moment(value).format(format);
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };

    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    // const getChangedFields = (newData, oldData) => {
    //     return Object.keys(newData).reduce((acc, key) => {
    //         if (Array.isArray(newData[key]) && Array.isArray(oldData[key])) {
    //             if (JSON.stringify(newData[key]) !== JSON.stringify(oldData[key])) {
    //                 acc[key] = newData[key];
    //             }
    //         } else if (newData[key] !== oldData[key]) {
    //             acc[key] = newData[key];
    //         }
    //         return acc;
    //     }, {});
    // };
    const successMessage = (titles, data) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => modal.destroy(),
        });
    }
    const mapApiResponseToFormValues = (value) => {
        return value.products.map((product) => ({
            addProductId: product.add_product_id,
            // adjustmentType: product.adjustment_type,
            productCategory: product.product_category,
            dealProductId: product.deal_product_id,
            productLicenseSellingPriceUnitMonth: product.product_license_selling_price_unitMonth,
            numberOfUnits: product.number_of_units,
            licenseDuration: product.license_duration,
            // subtotal: product.subtotal,
            // adjustments: product.adjustments,
            total: product.total
        }));
    };
    const mapApiResponseToServicesValues = (value) => {
        return value.service.map((service) => ({
            serviceId: service.service_id,
            serviceName: service.service_name,
            serviceLineId: service.service_line_id,
            serviceLineCost: service.service_line_cost,
        }));
    };
    const mapApiResponseToRoleValues = (value) => {
        return value.staffRoles.map((role) => ({
            staffRoleId: role.staff_role_id,
            addStaffRoleId: role.add_staff_role_id,
            roleName: role.roleName,
            country: role.country,
            rolePerDayRate: role.role_per_day_rate,
            startDate: role.start_date,
            endDate: role.end_date,
            totalValue: role.total_value,
        }));
    };
    function totalCalculation() {
        const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
        let sum = 0;
        let totalsum = 0;
        let Fvalue = 0;
        let profit = 0;
        if (typeAction === "Product and Services" || typeAction === "Request for Proposal" || typeAction === "Others") {
            if (isFormDataValid || isservicesDataValid) {
                if (formDatas.length === 0 && servicesData.length === 0) {
                    // sum = 1 * form.getFieldValue('grossdealValue');
                    sum = 1 * dealValues;
                }
                else {
                    if (formDatas.length > 0) {
                        for (let i = 0; i < formDatas.length; i += 1) {
                            if (formDatas[i].total !== undefined)
                                sum += 1 * formDatas[i].total;
                        }
                    }
                    else if (!isservicesDataValid) {
                        // sum = 1 * form.getFieldValue('grossdealValue');
                        sum = 1 * dealValues;
                    }
                    if (servicesData.length > 0) {
                        for (let i = 0; i < servicesData.length; i += 1) {
                            if (servicesData[i].serviceLineCost !== undefined)
                                sum += 1 * servicesData[i].serviceLineCost;
                        }
                    }
                    else if (!isFormDataValid) {
                        // sum = 1 * form.getFieldValue('grossdealValue');
                        sum = 1 * dealValues;
                    }
                }
            }
            else if (typeAction === "Request for Proposal" || typeAction === "Others") {
                // sum = 1 * form.getFieldValue('grossdealValue');
                sum = 1 * dealValues;
            }
        }
        if (typeAction === "Staff Augmentation") {
            for (let i = 0; i < roleData.length; i += 1) {
                if (roleData[i].totalValue !== undefined)
                    sum += 1 * roleData[i].totalValue;
            }
        }
        if (dealDiscount !== "0" && dealDiscount !== 0 && dealDiscount !== "" && dealDiscount !== null && dealDiscount !== undefined) {
            totalsum = sum * (1 - Number(dealDiscount) / 100)
        }
        else {
            totalsum = sum
        }
        if (winProbability !== undefined && winProbability !== "") {
            // Fvalue = sum * (1 - (1 * winProbability) / 100)
            // const dValue = 1 * form.getFieldValue('dealValue');
            if (totalDeal) {
                const dValue = 1 * totalDeal;
                Fvalue = dValue * (1 * winProbability / 100)
            }
        }
        if (pipeLineField !== "Won") {
            if (changeDealMargin !== undefined && changeDealMargin !== "") {
                if (totalDeal) {
                    const dValue = 1 * totalDeal;
                    profit = dValue * (1 * changeDealMargin / 100)
                }
            }
        }
        if (pipeLineField === "Won") {
            if (changeDealMargin2 !== undefined && changeDealMargin2 !== "") {
                if (totalDeal) {
                    const dValue = 1 * totalDeal;
                    profit = dValue * (1 * changeDealMargin2 / 100)
                }
            }
        }
        form.setFieldsValue({
            dealValue: totalsum?.toFixed(CurencyDecimalPlace), // .toLocaleString(),
            grossdealValue: sum?.toFixed(CurencyDecimalPlace),
            forecastedValue: Fvalue?.toFixed(CurencyDecimalPlace), // .toLocaleString(),
            dealProfit: profit?.toFixed(CurencyDecimalPlace)
        })
        setTotalDeal(totalsum);
    }
    const expectedClosureDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setExpectedClosureDate(formattedDate);
        // form.setFieldsValue({ expectedClosureDate: date });
        // form.validateFields(['revenueStartDate', 'revenueEndDate']);
    };
    const revenueStartDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setRevenueStartDate(formattedDate);
        // form.setFieldsValue({ revenueStartDate: date });
        // form.validateFields(['expectedClosureDate', 'revenueEndDate']);
    };
    const revenueEndDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setRevenueEndDate(formattedDate);
        // form.setFieldsValue({ revenueEndDate: date });
        // form.validateFields(['revenueStartDate']);
    };
    const onSubmit = async (values) => {

        let hideMessage;
        const ConvertRate = currencySettings?.exchangeRate;
        const { grossdealValue, dealValue, dealmargin, forecastedValue, winProbability, dealProfit } = values;
        const DealValue = dealValue
            ? await convertCurrency(ConvertRate, Number(dealValue))
            : dealValue;
        const ProfitValue = dealProfit
            ? await convertCurrency(ConvertRate, Number(dealProfit))
            : dealProfit;
        const GrossDealValue = grossdealValue
            ? await convertCurrency(ConvertRate, Number(grossdealValue))
            : grossdealValue;
        const ForecastedValue = forecastedValue
            ? await convertCurrency(ConvertRate, Number(forecastedValue))
            : forecastedValue;
        const formData =
        {
            dealProfit: normalizeValue(ProfitValue?.toString()),
            dealValue: normalizeValue(DealValue.toString()),
            expectedDealLength: normalizeValue(dealmargin),
            expectedClosureDate: normalizeValue(expectedClosureDate),
            winProbability: normalizeValue(winProbability),
            forecastedValue: normalizeValue(ForecastedValue.toString()),
            revenueStartDate: normalizeValue(revenueStartDate),
            revenueEndDate: normalizeValue(revenueEndDate),
            grossDealValue: normalizeValue(GrossDealValue.toString()),
            discountPercentage: normalizeValue(dealDiscount),
        }
        const updatedFields = getChangedFields(formData, dealInitial);
        if (Object.keys(updatedFields).length === 0) {
            message.success("Proposal updated")
            setEditWon(false)
            dispatch(setEditCall(false));
            setInLineFields(DealData)
            return;
        }
        try {

            hideMessage = message.loading("Loading...", 0);
            const response = await DealUpdate(updatedFields, displayData?.deals_id)
            if (response.status === 200) {
                hideMessage();
                if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                    setErrorData(response.data);
                    setIsModalVisible1(true);
                }
                else {
                    // eslint-disable-next-line no-lonely-if
                    if (response.data[0].message === AutomationMessage) {
                        if (displayDatas?.pipelineStage === "Won") {
                            dispatch(setExPoCall(true));
                            successMessage("Automation rule triggered", response.data[0].message)
                            setTimeout(() => {
                                dispatch(setExPoCall(false));
                            }, 3000);
                        } else {
                            successMessage("Automation rule triggered", response.data[0].message)
                        }
                    }
                    else if (response.data[0].message === ApprovalMessage) {
                        successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                    }
                    else if (response.data[0].message !== ApprovalMessage && response.data[0].message !== AutomationMessage) {
                        if (displayDatas?.pipelineStage === "Won") {
                            dispatch(setExPoCall(true));
                            successMessage("Proposal Won", "Proposal Closed! Congratulations on winning the deal! Time to celebrate your success")
                            setTimeout(() => {
                                dispatch(setExPoCall(false));
                            }, 3000);
                        } else {
                            message.success("Proposal pipeline updated successful");
                        }
                    } else {
                        message.success("Proposal pipeline updated successful");
                    }
                }
                message.success(response?.data)
                setEditWon(false)
                dispatch(setEditCall(false));
                getData()
                setInLineFields(DealData)
                setTrigger("activity")
            }
        }
        catch (error) {
            message.error(error)
        }
    }
    const setDataForDeal = async (value) => {
        if (value !== undefined) {
            const ConvertRates = currencySettings?.exchangeRate;
            const CurencyDecimalPlace = currencySettings?.decimalOfCurrency;
            const formValues = mapApiResponseToFormValues(value);
            const servicesValues = mapApiResponseToServicesValues(value);
            const roleValues = mapApiResponseToRoleValues(value)
            const ProfitDealValue = value.deal_profit && value.deal_profit !== "" ? await ExchangeCurrency(Number(value.deal_profit), ConvertRates) : value.deal_profit;
            const DealValue = value.deal_value ? await ExchangeCurrency(Number(value.deal_value), ConvertRates) : value.deal_value;
            const GrossDealValue = value.gross_deal_value ? await ExchangeCurrency(Number(value.gross_deal_value), ConvertRates) : value.gross_deal_value;
            const ForecastedValue = value.forecasted_value ? await ExchangeCurrency(Number(value.forecasted_value), ConvertRates) : value.forecasted_value;
            const convertedServicesData = await Promise.all(
                servicesValues.map(async (service) => {
                    const convertedCost = await (service.serviceLineCost !== undefined && service.serviceLineCost !== null && service.serviceLineCost !== "" ?
                        ExchangeCurrency(Number(service.serviceLineCost), ConvertRates)
                        : service.serviceLineCost
                    );
                    return {
                        ...service,
                        serviceLineCost: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            const convertedServices = await Promise.all(
                value.service.map(async (service) => {
                    const convertedCost = await (service.service_line_cost !== undefined && service.service_line_cost !== null && service.service_line_cost !== "" ?
                        ExchangeCurrency(Number(service.service_line_cost), ConvertRates)
                        : service.service_line_cost
                    );
                    return {
                        ...service,
                        service_line_cost: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            const convertedRoleData = await Promise.all(
                roleValues.map(async (role) => {
                    const convertedRate = await (role.rolePerDayRate !== undefined && role.rolePerDayRate !== null && role.rolePerDayRate !== ""
                        ? ExchangeCurrency(Number(role.rolePerDayRate), ConvertRates)
                        : role.rolePerDayRate);
                    const convertedTotalValue = await (role.totalValue !== undefined && role.totalValue !== null && role.totalValue !== ""
                        ? ExchangeCurrency(Number(role.totalValue), ConvertRates)
                        : role.totalValue);
                    return {
                        ...role,
                        rolePerDayRate: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                        totalValue: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            const convertedRole = await Promise.all(
                value.staffRoles.map(async (role) => {
                    const convertedRate = await (role.role_per_day_rate !== undefined && role.role_per_day_rate !== null && role.role_per_day_rate !== ""
                        ? ExchangeCurrency(Number(role.role_per_day_rate), ConvertRates) : role.role_per_day_rate);
                    const convertedTotalValue = await (role.total_value !== undefined && role.total_value !== null && role.total_value !== ""
                        ? ExchangeCurrency(Number(role.total_value), ConvertRates) : role.total_value);
                    return {
                        ...role,
                        role_per_day_rate: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                        total_value: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            const convertedFormDatas = await Promise.all(
                formValues.map(async (product) => {
                    const convertedPrice = await (product.productLicenseSellingPriceUnitMonth !== undefined && product.productLicenseSellingPriceUnitMonth !== '' && product.productLicenseSellingPriceUnitMonth !== null
                        ? ExchangeCurrency(Number(product.productLicenseSellingPriceUnitMonth), ConvertRates)
                        : product.productLicenseSellingPriceUnitMonth);
                    // const convertedSubtotal = await (product.subtotal !== undefined && product.subtotal !== '' && product.subtotal !== null
                    //     ? ExchangeCurrency(Number(product.subtotal), ConvertRates)
                    //     : product.subtotal);
                    const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                        ? ExchangeCurrency(Number(product.total), ConvertRates)
                        : product.total);
                    // let convertedAdjustments = product.adjustments;
                    // if (product.adjustments !== undefined && product.adjustments !== '' && product.adjustments !== null && product.adjustmentType !== "%") {
                    //     convertedAdjustments = await ExchangeCurrency(Number(product.adjustments), ConvertRates)
                    // }
                    return {
                        ...product,
                        productLicenseSellingPriceUnitMonth: Number(convertedPrice?.toFixed(CurencyDecimalPlace)),
                        // subtotal: Number(convertedSubtotal?.toFixed(CurencyDecimalPlace)),
                        total: Number(convertedTotal?.toFixed(CurencyDecimalPlace)),
                        // adjustments: product.adjustments !== undefined && product.adjustments !== '' && product.adjustments !== null && product.adjustmentType !== "%" ? Number(convertedAdjustments?.toFixed(CurencyDecimalPlace)) : convertedAdjustments,
                    };
                })
            );
            const convertedForm = await Promise.all(
                value.products.map(async (product) => {
                    const convertedPrice = await (product.product_license_selling_price_unitMonth !== undefined && product.product_license_selling_price_unitMonth !== '' && product.product_license_selling_price_unitMonth !== null
                        ? ExchangeCurrency(Number(product.product_license_selling_price_unitMonth), ConvertRates) : product.product_license_selling_price_unitMonth);
                    // const convertedSubtotal = await (product.subtotal !== undefined && product.subtotal !== '' && product.subtotal !== null
                    // ? ExchangeCurrency(Number(product.subtotal), ConvertRates) : product.subtotal);
                    const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                        ? ExchangeCurrency(Number(product.total), ConvertRates) : product.total);
                    // let convertedAdjustments = product.adjustments;
                    // if (product.adjustments !== undefined && product.adjustments !== '' && product.adjustments !== null && product.adjustment_type !== "%") {
                    //     convertedAdjustments = await ExchangeCurrency(Number(product.adjustments), ConvertRates)
                    // }
                    return {
                        ...product,
                        product_license_selling_price_unitMonth: Number(convertedPrice?.toFixed(CurencyDecimalPlace)),
                        // subtotal: Number(convertedSubtotal?.toFixed(CurencyDecimalPlace)),
                        total: Number(convertedTotal?.toFixed(CurencyDecimalPlace)),
                        // adjustments: product.adjustments !== undefined && product.adjustments !== '' && product.adjustments !== null && product.adjustment_type !== "%" ? Number(convertedAdjustments?.toFixed(CurencyDecimalPlace)) : convertedAdjustments,
                    };
                })
            );
            form.setFieldsValue({
                dealmargin: value.expected_deal_length,
                expectedClosureDate: value.expected_closure_date !== "" && value.expected_closure_date !== null ?
                    moment(formatDateString(value.expected_closure_date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
                    : null,
                winProbability: value.win_probability,
                forecastedValue: Number(ForecastedValue?.toFixed(CurencyDecimalPlace)),
                revenueStartDate: value.revenue_start_date !== "" && value.revenue_start_date !== null ?
                    moment(formatDateString(value.revenue_start_date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
                    : null,
                revenueEndDate: value.revenue_end_date !== "" && value.revenue_end_date !== null ?
                    moment(formatDateString(value.revenue_end_date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
                    : null,
                dealValue: Number(DealValue?.toFixed(CurencyDecimalPlace)),
                grossdealValue: Number(GrossDealValue?.toFixed(CurencyDecimalPlace)),
                discountvalue: value.discount_percentage,
                dealProfit: Number(ProfitDealValue?.toFixed(CurencyDecimalPlace)),
            })
            setPipeLineField(value.pipelineStage)
            setTypeAction(value.subtype)
            setDealValue(Number(GrossDealValue?.toFixed(CurencyDecimalPlace)))
            setTotalDeal(Number(DealValue?.toFixed(CurencyDecimalPlace)))
            setExpectedClosureDate(value.expected_closure_date)
            setRevenueStartDate(value.revenue_start_date)
            setRevenueEndDate(value.revenue_end_date)
            setWinProbability(value.win_probability)
            setDealDiscount(value.discount_percentage)
            setRoleData(convertedRoleData)
            setServiceData(convertedServicesData)
            setFormDatas(convertedFormDatas)
            totalCalculation()
            setChangeDealMargin(value.expected_deal_length)
            setChangeDealMargin2(value.actual_deal_margin !== undefined && value.actual_deal_margin !== null && value.actual_deal_margin !== "" ? value.actual_deal_margin : value.expected_deal_length)
            const updatedPerson = {
                ...value,
                gross_deal_value: Number(GrossDealValue?.toFixed(CurencyDecimalPlace)),
                deal_profit: Number(ProfitDealValue?.toFixed(CurencyDecimalPlace)),
                deal_value: Number(DealValue?.toFixed(CurencyDecimalPlace)),
                forecasted_value: Number(ForecastedValue?.toFixed(CurencyDecimalPlace)),
                products: convertedForm,
                service: convertedServices,
                staffRoles: convertedRole,
            };
            setDisplayDatas(updatedPerson)
        }
    }
    useEffect(() => {
        if (displayData) {
            setDataForDeal(displayData)
        }
    }, [displayData])
    useEffect(() => {
        if (displayDatas) {
            if (Role !== "Administrator") {
                if (displayDatas?.pipelineStage === "Won" || displayDatas?.pipelineStage === "Lost") {
                    setEditWon(true)
                }
                else {
                    setEdit(true)
                }
            }
            else {
                setEdit(true)
            }
        }
    }, [displayDatas])
    useEffect(() => {
        totalCalculation()
    }, [formDatas, servicesData, roleData, winProbability, typeAction, dealValues, dealDiscount, totalDeal, changeDealMargin])
    const handleEditFieldChange = (field) => {
        setInLineFields((prevValues) => ({
            ...prevValues,
            [field]: !prevValues[field],
        }));
    };
    return (
        <AddUser>
            <div className="user-info-form">
                <Form style={{ width: '100%' }} form={form} name="info" colon={false} onFinish={onSubmit} onFinishFailed={onFinishFailed}>
                    <BasicFormWrapper>
                        <div className="add-product-block">
                            <div className="add-product-content">
                                <Tabs defaultActiveKey="2">
                                    <TabPane tab="Basic Info" key="1">
                                        <Form.Item label="Proposal Urgency" name="priority" className="custom-form-item">
                                            <span className="">{displayDatas?.priority_name}</span>
                                        </Form.Item>
                                        <Form.Item label="Proposal Type" name="dealType" className="custom-form-item">
                                            <span className="">{displayDatas?.deal_type_name}</span>
                                        </Form.Item>
                                        <Form.Item label="Proposal SubType" name="typevalue" className="custom-form-item">
                                            <span className="">{displayDatas?.subtype}</span>
                                        </Form.Item>
                                        {displayDatas?.pipelineStage !== "Prospecting" && displayDatas?.pipelineStage !== "Qualification" && displayDatas?.pipelineStage !== "Discovery" &&
                                            <Form.Item label="Commit Status" name="commitstatus" className="custom-form-item">
                                                <span className="">{displayDatas?.commit_status}</span>
                                            </Form.Item>}
                                        <Form.Item label="Description" name="description" className="custom-form-item">
                                            <span className="">{displayDatas?.deal_description}</span>
                                        </Form.Item>
                                    </TabPane>
                                    <TabPane tab="Proposal Info" key="2">
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <div style={{ flex: 1 }}>
                                                <Form.Item label="Expected Proposal Margin" name="dealmargin" className="custom-form-item" rules={[
                                                    {
                                                        pattern: /^\d+(\.\d+)?$/,
                                                        message: 'Please enter a valid deal margin',
                                                    },
                                                ]}>
                                                    {inLineFields.expected_deal_margin ?
                                                        <Input
                                                            prefix="%"
                                                            pattern="^\d+(\.\d+)?$"
                                                            placeholder="Enter Expected Proposal Margin"
                                                            onChange={(e) => setChangeDealMargin(e.target.value)}
                                                        />
                                                        : <>
                                                            {displayData?.approved_for === "None" && canUpdateDelete(permissions, dataPermissions, "Update", 2015) && !editWon ?
                                                                <div
                                                                    className={edit ? "edit-span text_icon" : ""}
                                                                    style={{ display: "flex", alignItems: "center", cursor: edit ? "pointer" : "default" }}
                                                                >
                                                                    <span>% {displayData?.expected_deal_length}</span>
                                                                    {edit && <FeatherIcon icon="edit-3" size={16} className="btn-edit" onClick={() => handleEditFieldChange("expected_deal_margin")} />
                                                                    }
                                                                </div>
                                                                // <span className={edit ? "edit-span text_icon" : ""}>
                                                                //     % {displayData?.expected_deal_length}
                                                                //     </span>
                                                                : <span className='text_icon'>
                                                                    % {displayData?.expected_deal_length}
                                                                </span>}
                                                        </>}
                                                </Form.Item>
                                            </div>
                                            {inLineFields.expected_deal_margin ?
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 5, marginTop: 10 }}>
                                                    <div
                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                        role="button"
                                                        tabIndex={0}
                                                        title="Cancel"
                                                        onClick={() => {
                                                            handleEditFieldChange("expected_deal_margin"); getData()
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                handleEditFieldChange("expected_deal_margin"); getData()
                                                            }
                                                        }}
                                                        aria-label="cancel"
                                                    >
                                                        <FeatherIcon icon="x" size={20} className="btn-cancel" />
                                                    </div>
                                                    <div
                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                        role="button"
                                                        tabIndex={0}
                                                        title="Save"
                                                        onClick={() => form.submit()}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                form.submit();
                                                            }
                                                        }}
                                                        aria-label="save"
                                                    >
                                                        <FeatherIcon icon="check" size={20} className="btn-save" style={{ marginRight: 0 }} />
                                                    </div>
                                                </div> : <></>}
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <div style={{ flex: 1 }}> <Form.Item label="Win Probability" name="winProbability" className="custom-form-item"
                                                rules={displayDatas?.pipelineStage !== "Won" && displayDatas?.pipelineStage !== "Prospecting" && displayDatas?.deal_type_name !== "Empanelment" && edit && inLineFields.win_probability ?
                                                    [{ required: true, message: 'Please enter win probability', }
                                                        , {
                                                        pattern: /^\d+(\.\d+)?$/,
                                                        message: 'Please enter a valid win probability',
                                                    },
                                                    ] : [{ required: false }]}>
                                                {inLineFields.win_probability ?
                                                    <Input pattern="^\d+(\.\d+)?$" prefix="%" min={0} max={100} value={winProbability} onChange={(e) => setWinProbability(e.target.value)} /> :
                                                    <>
                                                        {displayDatas?.pipelineStage !== "Won" && displayData?.approved_for === "None" && canUpdateDelete(permissions, dataPermissions, "Update", 2015) && !editWon ?
                                                            <div
                                                                className={edit ? "edit-span text_icon" : ""}
                                                                style={{ display: "flex", alignItems: "center", cursor: edit ? "pointer" : "default" }}
                                                            >
                                                                <span> % {displayDatas?.win_probability}</span>
                                                                {edit && <FeatherIcon icon="edit-3" size={16} className="btn-edit" onClick={() => handleEditFieldChange("win_probability")} />
                                                                }
                                                            </div>
                                                            : <span className='text_icon'>
                                                                % {displayDatas?.win_probability}
                                                            </span>}
                                                    </>}
                                            </Form.Item>
                                            </div>
                                            {inLineFields.win_probability ?
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 5, marginTop: 10 }}>
                                                    <div
                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                        role="button"
                                                        tabIndex={0}
                                                        title="Cancel"
                                                        onClick={() => {
                                                            handleEditFieldChange("win_probability"); getData()
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                handleEditFieldChange("win_probability"); getData()
                                                            }
                                                        }}
                                                        aria-label="cancel"
                                                    >
                                                        <FeatherIcon icon="x" size={20} className="btn-cancel" />
                                                    </div>
                                                    <div
                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                        role="button"
                                                        tabIndex={0}
                                                        title="Save"
                                                        onClick={() => form.submit()}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                form.submit();
                                                            }
                                                        }}
                                                        aria-label="save"
                                                    >
                                                        <FeatherIcon icon="check" size={20} className="btn-save" style={{ marginRight: 0 }} />
                                                    </div>
                                                </div> : ""}
                                        </div>
                                        <Form.Item label={`Forecasted Value (${currencySettings?.currency})`} name="forecastedValue" className="custom-form-item">
                                            <span >{currencySettings?.symbol} {displayDatas?.forecasted_value?.toLocaleString()}</span>
                                        </Form.Item>
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <div style={{ flex: 1 }}><Form.Item label="Expected Closure Date" name="expectedClosureDate" className="custom-form-item"
                                                rules={displayDatas?.pipelineStage !== "Prospecting" && edit && inLineFields.expected_closure_date ?
                                                    [{ required: true, message: 'Please select a closure date', },
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            const startDate = getFieldValue('revenueStartDate');
                                                            if (!value || !startDate || value.isSameOrBefore(startDate, 'day')) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(new Error('Expected Closure Date cannot be later than Revenue Start Date'));
                                                        },
                                                    }),
                                                    ] : [{ required: false }, ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            const startDate = getFieldValue('revenueStartDate');
                                                            if (!value || !startDate || value.isSameOrBefore(startDate, 'day')) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(new Error('Expected Closure Date cannot be later than Revenue Start Date'));
                                                        },
                                                    }),]}>
                                                {inLineFields.expected_closure_date ? <DatePicker
                                                    format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                    value={expectedClosureDate ? moment(expectedClosureDate, "YYYY-MM-DD") : null}
                                                    onChange={expectedClosureDateChange}
                                                    disabledDate={disabledDate}
                                                /> : <>
                                                    {displayData?.approved_for === "None" && canUpdateDelete(permissions, dataPermissions, "Update", 2015) && !editWon ?
                                                        <div className={edit ? "edit-span text_icon" : ""} style={{ display: "flex", alignItems: "center", cursor: edit ? "pointer" : "default" }}
                                                        >
                                                            <span>{formatDate(displayDatas?.expected_closure_date, profile)}</span>
                                                            {edit && <FeatherIcon icon="edit-3" size={16} className="btn-edit" onClick={() => handleEditFieldChange("expected_closure_date")} />
                                                            } </div>
                                                        : <span className='text_icon'>
                                                            {formatDate(displayDatas?.expected_closure_date, profile)}
                                                        </span>}
                                                </>}
                                            </Form.Item></div>
                                            {inLineFields.expected_closure_date ?
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 5, marginTop: 10 }}>
                                                    <div
                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                        role="button"
                                                        tabIndex={0}
                                                        title="Cancel"
                                                        onClick={() => {
                                                            handleEditFieldChange("expected_closure_date"); getData()
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                handleEditFieldChange("expected_closure_date"); getData()
                                                            }
                                                        }}
                                                        aria-label="cancel"
                                                    >
                                                        <FeatherIcon icon="x" size={20} className="btn-cancel" />
                                                    </div>
                                                    <div
                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                        role="button"
                                                        tabIndex={0}
                                                        title="Save"
                                                        onClick={() => form.submit()}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                form.submit();
                                                            }
                                                        }}
                                                        aria-label="save"
                                                    >
                                                        <FeatherIcon icon="check" size={20} className="btn-save" style={{ marginRight: 0 }} />
                                                    </div>
                                                </div> : ""}
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <div style={{ flex: 1 }}> <Form.Item label="Revenue Start date" name="revenueStartDate" className="custom-form-item"
                                                rules={displayDatas?.pipelineStage !== "Prospecting" &&
                                                    displayDatas?.deal_type_name !== "Empanelment" &&
                                                    (edit || editWon) && inLineFields.revenue_start_date ?
                                                    [{ required: true, message: 'Please enter revenue start date' },
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            const closure = getFieldValue('expectedClosureDate');
                                                            const end = getFieldValue('revenueEndDate');

                                                            if (!value) return Promise.resolve();

                                                            if (closure && value.isBefore(closure, 'day')) {
                                                                return Promise.reject(new Error('Revenue Start Date cannot be before the Expected Closure Date'));
                                                            }
                                                            if (end && value.isAfter(end, 'day')) {
                                                                return Promise.reject(new Error('Revenue start date must be before the revenue end date'));
                                                            }

                                                            return Promise.resolve();
                                                        },
                                                    }),
                                                    ] : [{ required: false }, ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            const closure = getFieldValue('expectedClosureDate');
                                                            const end = getFieldValue('revenueEndDate');

                                                            if (!value) return Promise.resolve();

                                                            if (closure && value.isBefore(closure, 'day')) {
                                                                return Promise.reject(new Error('Revenue Start Date cannot be before the Expected Closure Date'));
                                                            }
                                                            if (end && value.isAfter(end, 'day')) {
                                                                return Promise.reject(new Error('Revenue start date must be before the revenue end date'));
                                                            }

                                                            return Promise.resolve();
                                                        },
                                                    }),]}>
                                                {inLineFields.revenue_start_date ?
                                                    <DatePicker onChange={revenueStartDateChange}
                                                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                        disabledDate={disabledDate}
                                                        disabled={typeAction === "Staff Augmentation"}
                                                    /> :
                                                    <>
                                                        {(displayData?.approved_for === "None" && canUpdateDelete(permissions, dataPermissions, "Update", 2015) && displayDatas?.subtype !== "Staff Augmentation") ?
                                                            <div className={(edit || editWon) ? "edit-span text_icon" : ""} style={{ display: "flex", alignItems: "center", cursor: edit ? "pointer" : "default" }}
                                                            >
                                                                <span>
                                                                    {formatDate(displayDatas?.revenue_start_date, profile)}</span>
                                                                {(edit || editWon) && <FeatherIcon icon="edit-3" size={16} className="btn-edit" onClick={() => handleEditFieldChange("revenue_start_date")} />
                                                                } </div>
                                                            : <span className='text_icon'>
                                                                {formatDate(displayDatas?.revenue_start_date, profile)}
                                                            </span>} </>}
                                            </Form.Item></div>
                                            {inLineFields.revenue_start_date ?
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 5, marginTop: 10 }}>
                                                    <div
                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                        role="button"
                                                        tabIndex={0}
                                                        title="Cancel"
                                                        onClick={() => {
                                                            handleEditFieldChange("revenue_start_date"); getData()
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                handleEditFieldChange("revenue_start_date"); getData()
                                                            }
                                                        }}
                                                        aria-label="cancel"
                                                    >
                                                        <FeatherIcon icon="x" size={20} className="btn-cancel" />
                                                    </div>
                                                    <div
                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                        role="button"
                                                        tabIndex={0}
                                                        title="Save"
                                                        onClick={() => form.submit()}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                form.submit();
                                                            }
                                                        }}
                                                        aria-label="save"
                                                    >
                                                        <FeatherIcon icon="check" size={20} className="btn-save" style={{ marginRight: 0 }} />
                                                    </div>
                                                </div> : ""}
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <div style={{ flex: 1 }}><Form.Item label="Revenue End Date" name="revenueEndDate" className="custom-form-item"
                                                rules={displayDatas?.pipelineStage !== "Prospecting" && displayDatas?.deal_type_name !== "Empanelment" && (edit || editWon) && inLineFields.revenue_end_date ? [{ required: true, message: 'Please enter revenue end date' },
                                                ({ getFieldValue }) => ({
                                                    validator(_, value) {
                                                        const start = getFieldValue('revenueStartDate');
                                                        if (!value || !start || value.isSameOrAfter(start, 'day')) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(new Error('Revenue End Date cannot be before the Revenue Start Date'));
                                                    },
                                                }),
                                                ] : [{ required: false }, ({ getFieldValue }) => ({
                                                    validator(_, value) {
                                                        const start = getFieldValue('revenueStartDate');
                                                        if (!value || !start || value.isSameOrAfter(start, 'day')) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(new Error('Revenue End Date cannot be before the Revenue Start Date'));
                                                    },
                                                }),]}>

                                                {inLineFields.revenue_end_date ? <DatePicker onChange={revenueEndDateChange} format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"} disabledDate={disabledDate} disabled={typeAction === "Staff Augmentation"} /> :
                                                    <>
                                                        {(displayData?.approved_for === "None" && canUpdateDelete(permissions, dataPermissions, "Update", 2015) && displayDatas?.subtype !== "Staff Augmentation") ?
                                                            <div className={(edit || editWon) ? "edit-span text_icon" : ""} style={{ display: "flex", alignItems: "center", cursor: edit ? "pointer" : "default" }}
                                                            >
                                                                <span>{formatDate(displayDatas?.revenue_end_date, profile)}</span>
                                                                {(edit || editWon) && <FeatherIcon icon="edit-3" size={16} className="btn-edit" onClick={() => handleEditFieldChange("revenue_end_date")} />
                                                                } </div>
                                                            : <span className='text_icon'>
                                                                {formatDate(displayDatas?.revenue_end_date, profile)}
                                                            </span>} </>}
                                            </Form.Item></div>
                                            {inLineFields.revenue_end_date ?
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 5, marginTop: 10 }}>
                                                    <div
                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                        role="button"
                                                        tabIndex={0}
                                                        title="Cancel"
                                                        onClick={() => {
                                                            handleEditFieldChange("revenue_end_date"); getData()
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                handleEditFieldChange("revenue_end_date"); getData()
                                                            }
                                                        }}
                                                        aria-label="cancel"
                                                    >
                                                        <FeatherIcon icon="x" size={20} className="btn-cancel" />
                                                    </div>
                                                    <div
                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                        role="button"
                                                        tabIndex={0}
                                                        title="Save"
                                                        onClick={() => form.submit()}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                form.submit();
                                                            }
                                                        }}
                                                        aria-label="save"
                                                    >
                                                        <FeatherIcon icon="check" size={20} className="btn-save" style={{ marginRight: 0 }} />
                                                    </div>
                                                </div> : ""}
                                        </div>
                                        <Form.Item label={`Gross Proposal Value (${currencySettings?.currency})`} name="grossdealValue" className="custom-form-item">
                                            <span > {currencySettings?.symbol} {displayDatas && displayDatas.gross_deal_value && displayDatas.gross_deal_value.toLocaleString()}</span>
                                        </Form.Item>
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                            <div style={{ flex: 1 }}><Form.Item label="Discount Percentage" name="discountvalue" className="custom-form-item" rules={[
                                                {
                                                    pattern: /^\d+(\.\d+)?$/,
                                                    message: 'Please enter a valid discount',
                                                },
                                            ]}>
                                                {inLineFields.discount_percentage ?
                                                    <Input pattern="^\d+(\.\d+)?$" prefix="%" placeholder='Enter Discount Percentage' value={dealDiscount}
                                                        onChange={(e) => setDealDiscount(e.target.value)} /> :
                                                    <>
                                                        {displayData?.approved_for === "None" && canUpdateDelete(permissions, dataPermissions, "Update", 2015) && !editWon ?
                                                            <div className={edit ? "edit-span text_icon" : ""} style={{ display: "flex", alignItems: "center", cursor: edit ? "pointer" : "default" }}
                                                            >
                                                                <span> % {displayData?.discount_percentage}</span>
                                                                {edit && <FeatherIcon icon="edit-3" size={16} className="btn-edit" onClick={() => handleEditFieldChange("discount_percentage")} />
                                                                } </div>
                                                            : <span className='text_icon'>
                                                                % {displayData?.discount_percentage}
                                                            </span>}
                                                    </>}
                                            </Form.Item></div>
                                            {inLineFields.discount_percentage ?
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 5, marginTop: 10 }}>
                                                    <div
                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                        role="button"
                                                        tabIndex={0}
                                                        title="Cancel"
                                                        onClick={() => {
                                                            handleEditFieldChange("discount_percentage"); getData()
                                                        }}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                handleEditFieldChange("discount_percentage"); getData()
                                                            }
                                                        }}
                                                        aria-label="cancel"
                                                    >
                                                        <FeatherIcon icon="x" size={20} className="btn-cancel" />
                                                    </div>
                                                    <div
                                                        className="Hover-Refresh2 back-hover1 able-style"
                                                        role="button"
                                                        tabIndex={0}
                                                        title="Save"
                                                        onClick={() => form.submit()}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                form.submit();
                                                            }
                                                        }}
                                                        aria-label="save"
                                                    >
                                                        <FeatherIcon icon="check" size={20} className="btn-save" style={{ marginRight: 0 }} />
                                                    </div>
                                                </div> : ""}
                                        </div>
                                        <Form.Item label={`Proposal Value (${currencySettings?.currency})`} name="dealValue" className="custom-form-item">
                                            {currencySettings?.symbol} {displayDatas && displayDatas.deal_value && displayDatas.deal_value.toLocaleString()}
                                        </Form.Item>
                                        <Form.Item label={`Proposal Profit (${currencySettings?.currency})`} name="dealProfit" className="custom-form-item">
                                            {currencySettings?.symbol} {displayDatas && displayDatas.deal_profit && displayDatas.deal_profit.toLocaleString()}
                                        </Form.Item>
                                    </TabPane>
                                    {(displayDatas?.pipelineStage === "Won" || displayDatas?.pipelineStage === "Lost" || displayDatas?.pipelineStage === "on-Hold" || displayDatas?.pipelineStage === "On-Hold") &&
                                        <TabPane tab={`Proposal ${displayDatas?.pipelineStage} Info`} key="3">
                                            {displayDatas?.pipelineStage === "Won" ? <>
                                                <Form.Item label="Actual Closure Date" name="actualclosureDate" className="custom-form-item">
                                                    {formatDate(displayDatas?.actual_closer_date, profile)}
                                                </Form.Item>
                                                <Form.Item label="Actual Proposal Margin" name="actualdealmargin" className="custom-form-item">
                                                    % {displayDatas !== undefined && displayDatas.actual_deal_margin}
                                                </Form.Item>
                                                <Form.Item label="Proposal Won Reason" name="dealWonreasons" className="custom-form-item">
                                                    {displayDatas !== undefined && displayDatas.dealWonReasonName}
                                                </Form.Item></> :
                                                displayDatas?.pipelineStage === "Lost" ? <>
                                                    <Form.Item label="Proposal Lost Date" name="dealLostDate" className="custom-form-item">
                                                        {formatDate(displayDatas?.deal_lost_date, profile)}
                                                    </Form.Item>
                                                    <Form.Item label="Proposal Lost Reason" name="deallostReasons" className="custom-form-item">
                                                        {displayDatas !== undefined && displayDatas.dealLostReasonName}
                                                    </Form.Item>
                                                </> :
                                                    (displayDatas?.pipelineStage === "on-Hold" || displayDatas?.pipelineStage === "On-Hold") ? <>
                                                        <Form.Item label="Proposal On-Hold Date" name="dealonholdDate" className="custom-form-item">
                                                            {formatDate(displayDatas?.deal_hold_date, profile)}
                                                        </Form.Item>
                                                        <Form.Item label="Proposal Restart Date" name="dealrestartDate" className="custom-form-item">
                                                            {formatDate(displayDatas?.deal_restart_date, profile)}
                                                        </Form.Item>
                                                        <Form.Item label="Proposal On-Hold Reason" name="dealonHoldReason" className="custom-form-item">
                                                            {displayDatas !== undefined && displayDatas.dealOnholdReasonName}
                                                        </Form.Item>
                                                    </> : <></>}
                                        </TabPane>}
                                    <TabPane tab="Other Info" key={(displayDatas?.pipelineStage === "Won" || displayDatas?.pipelineStage === "Lost" || displayDatas?.pipelineStage === "on-Hold" || displayDatas?.pipelineStage === "On-Hold") ? "4" : "3"}>
                                        <Form.Item label="Created By" className="custom-form-item" >
                                            {displayDatas?.created_by ?
                                                <DetailsOtherInfoUser record={{
                                                    recordby: displayData?.created_by,
                                                    recordbyFName: displayData?.createdByFirstName,
                                                    recordbyLName: displayData?.createdByLastName,
                                                    date: displayData?.created_at
                                                }} /> : <></>}
                                        </Form.Item>
                                        <Form.Item label="Modified By" className="custom-form-item">
                                            {displayDatas?.modified_by ?
                                                <DetailsOtherInfoUser record={{
                                                    recordby: displayData?.modified_by,
                                                    recordbyFName: displayData?.modifiedByFirstName,
                                                    recordbyLName: displayData?.modifiedByLastName,
                                                    date: displayData?.modified_at
                                                }} /> : <></>}
                                        </Form.Item>
                                    </TabPane>
                                </Tabs>
                            </div>
                        </div>
                    </BasicFormWrapper>
                </Form >
            </div>
        </AddUser >
    )
}
LeadTabPage.propTypes = {
    displayData: PropTypes.object.isRequired,
    currencySettings: PropTypes.object.isRequired,
    dealInitial: PropTypes.object.isRequired,
    canUpdateDelete: PropTypes.func.isRequired,
    getData: PropTypes.func.isRequired,
    setTrigger: PropTypes.func.isRequired,
    permissions: PropTypes.object.isRequired,
    DealData: PropTypes.object.isRequired,
    dataPermissions: PropTypes.string.isRequired,
    ApprovalMessage: PropTypes.string.isRequired,
    AutomationMessage: PropTypes.string.isRequired,
    setErrorData: PropTypes.func.isRequired,
    setIsModalVisible1: PropTypes.func.isRequired,
}
export default LeadTabPage;
